export default value => value.trim().length > 1;
